<script setup lang="ts">
defineProps<{ position: "top" | "bottom" }>()

const products = useProductVariantsStore()

// Different product states
const productReleased = computed(() => {
  if (products.activeVariant) {
    return products.activeVariant.isReleased
  } else {
    return products.productVariants.some(p => p.isReleased)
  }
})

const variant = computed(() => products.activeProduct?.variants.find(v => !!v.ean))
</script>

<template>
  <section
    class="flex w-full items-center justify-center"
    :class="{ 'bg-[--theme-lighter]': position === 'bottom' }"
  >
    <div
      class="max-w-[90em]"
      :class="{
        'flex grid-cols-2 flex-col place-items-center gap-6 lg:grid':
          position === 'top',
        'flex items-center justify-center': position === 'bottom',
      }"
    >
      <UProductImage
        v-if="position === 'top' && variant"
        :product="variant"
        loading="eager"
        class="flex max-w-[248px] items-center justify-center md:max-w-[400px] lg:order-2 lg:max-w-[465px] lg:self-start"
        img-class="w-fit max-w-full rounded-lg object-contain"
      />
      <div
        v-if="products.activeProduct"
        class="flex flex-col gap-5 lg:gap-10 lg:px-0"
        :class="{
          'text-center ': position === 'bottom',
          'text-left ': position === 'top',
        }"
      >
        <div v-if="position === 'top'">
          <h2
            class="hyphens-auto text-pretty text-center font-numeraWebRegular text-marketing-mobile-h2-h2-caption text-[--theme-darkest] md:text-marketing-desktop-h2-h2-caption lg:text-left xl:gap-10"
            v-html="products.activeProduct?.header"
          />

          <h3
            v-if="!productReleased"
            class="text-center font-national2condensed text-marketing-mobile-p1-p1-regular-m text-[--theme-dark] lg:text-left lg:text-marketing-desktop-p1-p1-regular-s"
          >
            Produktet lanseres snart, da kan du prøve oss helt gratis
          </h3>
        </div>

        <UProductActions
          v-if="products.activeProduct"
          :product="products.activeProduct"
          view-type="detail"
          :align="position === 'bottom' ? 'center' : 'left'"
          :show-status-details="true"
        />
      </div>
    </div>
  </section>
</template>
